import { PageVariableType } from "./page-variable";

/**
 * Each type's `defaultPath` mirrors the path ihf-root gives a new page row, from
 * `data-jpa/src/main/java/com/ihomefinder/domain/constants/ClientPageType.java`. Keep in sync;
 * nothing checks this at runtime. The pages API returns only a row's current path, so once a client
 * edits it the default is no longer knowable from the row.
 */
class Type {

	public static DEFAULT = new Type(1, "Default", "/idx");
	public static LISTING = new Type(2, "Listing Details", "/listing?id={id}", [
		PageVariableType.LISTING_ADDRESS,
		PageVariableType.LISTING_CITY,
		PageVariableType.LISTING_POSTAL_CODE,
		PageVariableType.LISTING_PHOTO_URL,
		PageVariableType.LISTING_PHOTO_WIDTH,
		PageVariableType.LISTING_PHOTO_HEIGHT,
		PageVariableType.LISTING_PRICE,
		PageVariableType.LISTING_SOLD_PRICE,
		PageVariableType.LISTING_SQUARE_FEET,
		PageVariableType.LISTING_BEDROOOMS,
		PageVariableType.LISTING_BATHROOMS,
		PageVariableType.LISTING_NUMBER,
		PageVariableType.LISTING_DESCRIPTION,
	]);
	public static LISTINGS = new Type(3, "Search", "/listings");
	public static EMAIL_ALERTS = new Type(4,"Email Alerts", "/email-alerts");
	public static FEATURED_LISTINGS = new Type(5, "Featured Listings", "/featured-listings");
	public static PENDING_FEATURED_LISTINGS = new Type(6, "Pending Featured Listings", "/pending-featured-listings");
	public static SOLD_FEATURED_LISTINGS = new Type(7, "Sold Featured Listings", "/sold-featured-listings");
	public static OPEN_HOME_LISTINGS = new Type(8, "Open House Listings", "/open-home-listings");
	public static SUPPLEMENTAL_LISTINGS = new Type(9, "Supplemental Listings", "/supplemental-listings");
	public static HOT_SHEETS = new Type(10, "Markets", "/markets");
	public static LISTING_REPORT = new Type(11, "Listing Report", "/listing-report?id={id}", [
		PageVariableType.MARKET_NAME,
		PageVariableType.MARKET_DESCRIPTION,
	]);
	public static OPEN_HOME_REPORT = new Type(12, "Open House Report", "/open-home-report?id={id}", [
		PageVariableType.MARKET_NAME,
		PageVariableType.MARKET_DESCRIPTION,
	]);
	public static MARKET_REPORT = new Type(13, "Market Report", "/market-report?id={id}", [
		PageVariableType.MARKET_ID,
		PageVariableType.MARKET_NAME,
		PageVariableType.MARKET_DESCRIPTION,
	]);
	public static PROPERTY_ORGANIZER = new Type(14, "Property Organizer", "/property-organizer");
	public static CONTACT_FORM = new Type(15, "Contact Form", "/contact");
	public static VALUATION_FORM = new Type(16, "Valuation Form", "/valuation");
	public static MORTGAGE_CALCULATOR = new Type(17, "Mortgage Calculator", "/mortgage-calculator");
	public static AGENT = new Type(18, "Agent Profile", "/agent?id={id}", [
		PageVariableType.AGENT_ID,
		PageVariableType.AGENT_NAME,
		PageVariableType.AGENT_DESIGNATION,
	]);
	public static AGENTS = new Type(19,"Agents", "/agents");
	public static OFFICE = new Type(20, "Office Profile", "/office?id={id}", [
		PageVariableType.OFFICE_ID,
		PageVariableType.OFFICE_NAME
	]);
	public static OFFICES = new Type(21, "Offices", "/offices");

	private constructor(
		public readonly id: number,
		public readonly label: string,
		public readonly defaultPath?: string,
		public readonly variables?: PageVariableType[],
	) {
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id: number) {
		return this.values().find(value => value.id === id);
	}

}

export { Type as PageType };
